customElements.get("review-company") || customElements.define("review-company", class extends HTMLElement {
  constructor() {
    super(), this.ratingNumberEl = this.querySelector("[data-rating-number]"), this.ratingStarsEl = this.querySelector("[data-rating-stars]"), 
    this.ratingCountEl = this.querySelector("[data-rating-count]"), this.ratingTextEl = this.querySelector("[data-rating-text]");
  }
  async connectedCallback() {
    const t = this.dataset.manualRatingNumber, e = this.dataset.manualRatingTotal;
    if (t && e) this.displayManualRating(parseFloat(t), parseInt(e)); else if (window.Shopify?.app_config?.reviews_io?.store) try {
      const t = await fetch(`https://api.reviews.io/stats/all?store=${window.Shopify.app_config.reviews_io.store}`, {
        headers: {
          accept: "application/json"
        }
      });
      if (!t.ok) throw new Error(`HTTP error! status: ${t.status}`);
      const {company_review_stats: e} = await t.json();
      if (0 === parseFloat(e?.average_rating)) return void (this.style.display = "none");
      const i = t => {
        const e = String(t);
        if (e.includes(".")) {
          const [t, i] = e.split(".");
          return i.length > 1 ? `${t}.${i.slice(0, 1)}` : e;
        }
        return e;
      }, a = t => {
        const e = Math.max(0, Math.min(5, parseFloat(t))), i = Math.floor(e), a = 2.73 + 18 * i + 9.51 * (e - i);
        return Math.min(a / 86 * 100, 100);
      };
      [ e?.average_rating && this.ratingNumberEl && (this.ratingNumberEl.textContent = i(parseFloat(parseFloat(e.average_rating).toFixed(2)))), e?.average_rating && this.ratingStarsEl && (this.ratingStarsEl.style.width = `${a(e.average_rating)}%`), void 0 !== e?.total_reviews && this.ratingCountEl && (this.ratingCountEl.textContent = e.total_reviews.toLocaleString()) ].some(Boolean) && (this.ratingTextEl && (this.ratingTextEl.textContent = `${e?.total_reviews > 1 ? window.strings?.review?.other : window.strings?.review?.one}`), 
      this.classList.remove("hidden"), this.classList.add("flex"), setTimeout(() => this.classList.remove("opacity-0", "pointer-events-none"), 100));
    } catch (t) {
      console.error("Error fetching company review stats:", t);
    }
  }
  displayManualRating(t, e) {
    this.ratingNumberEl && (this.ratingNumberEl.textContent = (t => {
      const e = String(t);
      if (e.includes(".")) {
        const [t, i] = e.split(".");
        return i.length > 1 ? `${t}.${i.slice(0, 1)}` : e;
      }
      return e;
    })(t)), this.ratingStarsEl && (this.ratingStarsEl.style.width = `${(t => {
      const e = Math.max(0, Math.min(5, parseFloat(t))), i = Math.floor(e), a = 2.73 + 18 * i + 9.51 * (e - i);
      return Math.min(a / 86 * 100, 100);
    })(t)}%`), this.ratingCountEl && (this.ratingCountEl.textContent = e.toLocaleString()), 
    this.ratingTextEl && (this.ratingTextEl.textContent = `${e > 1 ? window.strings?.review?.other : window.strings?.review?.one}`), 
    this.classList.remove("hidden", "opacity-0", "pointer-events-none"), this.classList.add("flex");
  }
});